export const SALES_PAGE_SIZE = 25

/** The next `offset` to request, from the server's total; `undefined` once everything matching is loaded. */
export function nextSalesOffset(loaded: number, total: number): number | undefined {
  return loaded < total ? loaded : undefined
}
